module.exports = __webpack_public_path__ + "img/multi.6d29bfd1.png";